module.exports = __webpack_public_path__ + "static/media/header-img.f2ee7bd0.png";